import { takeLatest } from 'redux-saga/effects';
import {
  getReferralListSuccess, getReferralListFail,
  getReferralDetailsSuccess, getReferralDetailsFail
} from './referralState';
import createCrudService from '../../services/crudservice';
import { doCrudCall, SAVING_MSG, UPDATING_MSG, DELETING_MSG, LOADING_MSG,
	createRecordSuccess, updateRecordSuccess, deleteRecordSuccess 
	} from '../../utils/crudSagaHelper';

import { loginRequest } from '../auth/authState';

const crudService = createCrudService('api/v1/console/referrals');
const redirectData = {route:'/console/referrals', mode: 'list', recordId:0 };
const modelName = 'Referral';
const modelId = 'id';
const referralRegService = createCrudService('api/v1');

function* getReferralList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload), 
		getReferralListSuccess, 
		getReferralListFail,
		null, null, LOADING_MSG);
}

function* getReferralDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload), 
		getReferralDetailsSuccess, 
		getReferralDetailsFail,
		null, null, LOADING_MSG);		
}

function* doReferralCreate(data){
	yield doCrudCall(
		() => crudService.doCreate(data.payload), 
		getReferralDetailsSuccess, 
		getReferralDetailsFail,
		createRecordSuccess(modelName),
		redirectData, SAVING_MSG);
}

function* doReferralUpdate(data){
	yield doCrudCall(
		() => crudService.doUpdate(data.payload[modelId], data.payload), 
		getReferralDetailsSuccess, 
		getReferralDetailsFail,
		updateRecordSuccess(modelName),
		redirectData, UPDATING_MSG);	
}

function* doReferralDelete(data){
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId), 
		getReferralDetailsSuccess, 
		getReferralDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData, mode: data.payload.mode},
		DELETING_MSG);	
}

function* getReferralCodeDetails(data) {
	const { code } = data.payload;
	yield doCrudCall(
		() => referralRegService.doPublicGetRequest(`referral-code/details/${code}`,data.payload), 
		getReferralDetailsSuccess, 
		getReferralDetailsFail,
		null, null, LOADING_MSG);		
}

function* doReferralRegistration(data){
	const { email, password, ref_job_post_id } = data.payload;
	yield doCrudCall(
		() => referralRegService.doPublicPostRequest('referral-registration',data.payload), 
		getReferralDetailsSuccess, 
		getReferralDetailsFail,
		createRecordSuccess(modelName),
		{route:`job-posts/${ref_job_post_id}/view`, mode: 'list', recordId:0 }, 
		'Registration in progress.'
	);
}


function* referralSaga() {
  yield takeLatest('referral/getReferralList', getReferralList);
  yield takeLatest('referral/getReferralDetails', getReferralDetails);
  yield takeLatest('referral/doReferralCreate', doReferralCreate);
  yield takeLatest('referral/doReferralUpdate', doReferralUpdate);
  yield takeLatest('referral/doReferralDelete', doReferralDelete);  
  yield takeLatest('referral/getReferralCodeDetails', getReferralCodeDetails);
  yield takeLatest('referral/doReferralRegistration', doReferralRegistration);
}

export default referralSaga;
